import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router';
import Navbar from '../src/Navbar';
import Home from '../src/Home';
import Book from '../src/Book';
import Story from '../src/Story';
import Menu from '../src/Menu';
import Contact from '../src/Contact';
import Footer from '../src/Footer';

function App() {
  return (
    <div className="map-wrapper-div"> 
      <Router>
      <Navbar />
        <Routes>
        <Route path="/" element={<Home />} />
          <Route path="/book" element={<Book />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/our-story" element={<Story />} />
          <Route path="/menu" element={<Menu />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
